/**
 * {@link - https://stackoverflow.com/questions/21125337/how-to-detect-if-web-app-running-standalone-on-chrome-mobile}
 * {@link - https://web.dev/customize-install/#detect-launch-type}
 */
function getPWADisplayMode() {
  const navigatorAlias = navigator as any
  const isInWebAppiOS = navigatorAlias?.standalone === true
  const isInWebAppChrome = window.matchMedia('(display-mode: standalone)').matches

  if (document.referrer.indexOf('android-app://') === 0) {
    return 'twa'
  } else if (isInWebAppiOS || isInWebAppChrome) {
    return 'standalone'
  }
  return 'browser'
}

const isAppInRunningTabBrowser = () => getPWADisplayMode() === 'browser'

export {getPWADisplayMode, isAppInRunningTabBrowser}
